import type { Technique } from '../types.js';
import type { LineDeduction, SolverLine } from './types.js';
import {
  trivialLine,
  simpleOverlap,
  edgeLogic,
  spaceFilling,
} from './techniques.js';

export interface LineSolveResult {
  deductions: LineDeduction[];
  technique: Technique | null;
}

/**
 * Solve a single line by applying techniques in order of complexity.
 * Returns the deductions from the first technique that produces results.
 */
export function solveLine(
  line: SolverLine,
  clues: number[]
): LineSolveResult {
  const techniques: Array<{
    name: Technique;
    fn: (line: SolverLine, clues: number[]) => LineDeduction[];
  }> = [
    { name: 'trivialLine', fn: trivialLine },
    { name: 'simpleOverlap', fn: simpleOverlap },
    { name: 'edgeLogic', fn: edgeLogic },
    { name: 'spaceFilling', fn: spaceFilling },
  ];

  for (const { name, fn } of techniques) {
    const deductions = fn(line, clues);
    if (deductions.length > 0) {
      return { deductions, technique: name };
    }
  }

  return { deductions: [], technique: null };
}
